import {ILookupEntry} from 'shared/types/lookups';
import {ERequestType} from 'shared/types/requests';
import {performRequest} from 'shared/utils';

import {
    TDrillUpTreeResponse, ITableReportConfigRequestParams, ITableReportDataRequestParams, TTableReportExtendedConfiguration,
} from './table-report-slice-types';

export interface IFetchTableReportTemplateConfigArgs {
    templateCode: string;
    isExtended: boolean;
    params: ITableReportConfigRequestParams;
}
export const fetchTableReportTemplateConfig = (
    {
        templateCode,
        params,
        isExtended,
    }: IFetchTableReportTemplateConfigArgs,
) => {
    if (isExtended) {
        return performRequest<TTableReportExtendedConfiguration>({
            url: `table-reports/${templateCode}/config/ext`,
            method: 'POST',
            data: params,
        });
    }
    return performRequest<TTableReportExtendedConfiguration>({
        url: `table-reports/${templateCode}`,
        method: 'GET',
        params,
    });
};

export const fetchTableReportData = ({
    templateCode,
    docId,
    page,
    size,
    filters,
    sort,
    includeCR,
    parameters,
    includeComparison,
    comparedDocId,
    drillParameters,
    userReportGroups,
    groupAfterUserFilter,
    addHiddenData,
    includeControlRatioBySettings,
}: ITableReportDataRequestParams) => performRequest({
    url: `table-reports/${templateCode}/data`,
    data: {
        DOC_ID: docId,
        DOC_ID_2: comparedDocId,
        page,
        size,
        filters,
        sort,
        includeCR,
        parameters,
        includeComparison,
        drillParameters,
        userReportGroups,
        groupAfterUserFilter,
        addHiddenData,
        includeControlRatioBySettings,
    },
    method: 'POST',
});

export const fetchTableReportFiltersConditions = () => performRequest<ILookupEntry[]>({
    url: 'lookupValue/TABLE_REPORT_FILTER_VIEW',
    method: 'GET',
});

export const fetchDrillUpTree = (
    docId: string, key: string, value: string | number,
) => performRequest<TDrillUpTreeResponse>({
    url: `table-reports/drill-up/${docId}`,
    method: ERequestType.POST,
    data: {
        key,
        value,
    },
});
